import type { FC, ReactNode } from 'react'
import type { PhotoId } from '@/components/generals/photo'

import { cn } from '@/lib/utils'
import { Photo } from '@/components/generals/photo'

interface HiringManagerPaneProps {
    photo: PhotoId
    /** The person's name, for the photo's description. */
    name: string
    className?: string
}

/** The recessed photo window of a stacked card: the hiring manager's portrait and a signature in the corner. */
export const HiringManagerPane: FC<HiringManagerPaneProps> = ({ photo, name, className }): ReactNode => {
    return (
        <div className={cn('relative h-full min-h-[320px] w-full overflow-hidden rounded-lg max-md:aspect-[3/2] max-md:h-auto max-md:min-h-0', className)}>
            <Photo id={photo} alt={`Portrait of ${name}`} sizes='(min-width: 768px) 520px, 100vw' className='absolute inset-0 size-full' />

            <span aria-hidden='true' className='hand pointer-events-none absolute bottom-[3.5%] right-[3%] z-[2] whitespace-nowrap rounded-[3px] bg-paper/85 px-2.5 pb-1 pt-2 text-[clamp(17px,1.7vw,23px)] leading-none text-ink/70 shadow-[0_6px_14px_-8px_rgb(40_38_34/0.45)] [rotate:-6deg]'>
                Hiring Manager
            </span>

            <span aria-hidden='true' className='pointer-events-none absolute inset-0 z-[3] rounded-lg border border-ink/15' />
        </div>
    )
}
